import { useContext } from 'react'

import HeaderContext from '../components/Header/HeaderContext'

const useHeader = () => {
  return useContext(HeaderContext)
}

export default useHeader
